import { SavedSearch } from "../../../types/neighborhoodSearch";

/**
 * Determines if a saved search is an address-based search by checking if
 * it has a searchAddress field in its search parameters. For backwards compatibility,
 * also checks if combinedSearchSources, searchFilters, and searchRegion are all empty.
 */
export const isAddressSavedSearch = (search: SavedSearch): boolean => {
  const { search_parameters } = search;
  
  if (!search_parameters) {
    return false;
  }

  if (search_parameters.searchAddress) {
    return true;
  }

  // Backwards compatibility: Check if other fields are empty/undefined (for old saved searches)
  const { combinedSearchSources, searchFilters, searchRegion } = search_parameters;

  // Check if combinedSearchSources is empty or undefined
  const isCombinedSearchSourcesEmpty = 
    !combinedSearchSources || combinedSearchSources.length === 0;

  // Check if searchFilters is empty or undefined
  const isSearchFiltersEmpty = !searchFilters;

  // Check if searchRegion is empty or undefined
  const isSearchRegionEmpty = !searchRegion;

  return isCombinedSearchSourcesEmpty && isSearchFiltersEmpty && isSearchRegionEmpty;
};